import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const universities = [
  {
    id: 'harvard',
    name: 'Harvard University',
    location: 'Cambridge, Massachusetts',
    image: 'https://public.readdy.ai/ai/img_res/591dfdf3860437261fe7f4f5414b7140.jpg',
    programs: 'Business, Droit, Médecine, Sciences',
    programsEn: 'Business, Law, Medicine, Sciences',
    ranking: '#1 Mondial',
    rankingEn: '#1 Worldwide',
  },
  {
    id: 'stanford',
    name: 'Stanford University',
    location: 'Stanford, California',
    image: 'https://readdy.ai/api/search-image?query=Stanford%20University%20campus%20with%20Spanish%20colonial%20architecture%2C%20palm%20trees%20and%20sandstone%20buildings%2C%20Silicon%20Valley%20location%2C%20modern%20technology-focused%20university%20environment%2C%20sunny%20California%20weather%2C%20professional%20photography%20style&width=600&height=400&seq=univ-002&orientation=landscape',
    programs: 'Ingénierie, Informatique, Business',
    programsEn: 'Engineering, Computer Science, Business',
    ranking: '#2 Mondial',
    rankingEn: '#2 Worldwide',
  },
  {
    id: 'mit',
    name: 'MIT',
    location: 'Cambridge, Massachusetts',
    image: 'https://readdy.ai/api/search-image?query=Massachusetts%20Institute%20of%20Technology%20MIT%20campus%20with%20modern%20architecture%20and%20iconic%20dome%20building%2C%20students%20with%20laptops%20and%20technology%2C%20innovative%20research%20environment%2C%20contemporary%20educational%20setting%2C%20professional%20photography&width=600&height=400&seq=univ-003&orientation=landscape',
    programs: 'Sciences, Technologie, Ingénierie',
    programsEn: 'Sciences, Technology, Engineering',
    ranking: '#3 Mondial',
    rankingEn: '#3 Worldwide',
  },
  {
    id: 'columbia',
    name: 'Columbia University',
    location: 'New York, New York',
    image: 'https://readdy.ai/api/search-image?query=Columbia%20University%20campus%20in%20New%20York%20City%20with%20neoclassical%20buildings%20and%20urban%20setting%2C%20diverse%20students%20on%20campus%20grounds%2C%20Ivy%20League%20institution%2C%20metropolitan%20academic%20environment%2C%20professional%20photography%20style&width=600&height=400&seq=univ-004&orientation=landscape',
    programs: 'Arts Libéraux, Journalisme, Business',
    programsEn: 'Liberal Arts, Journalism, Business',
    ranking: '#6 Mondial',
    rankingEn: '#6 Worldwide',
  },
  {
    id: 'berkeley',
    name: 'University of California',
    location: 'Berkeley, California',
    image: 'https://readdy.ai/api/search-image?query=UC%20Berkeley%20campus%20with%20Sather%20Tower%20and%20green%20spaces%2C%20students%20studying%20outdoors%2C%20public%20research%20university%20atmosphere%2C%20California%20sunshine%2C%20diverse%20student%20body%2C%20professional%20photography%20style&width=600&height=400&seq=univ-005&orientation=landscape',
    programs: 'Sciences, Ingénierie, Sciences Sociales',
    programsEn: 'Sciences, Engineering, Social Sciences',
    ranking: '#4 Public',
    rankingEn: '#4 Public',
  },
  {
    id: 'yale',
    name: 'Yale University',
    location: 'New Haven, Connecticut',
    image: 'https://readdy.ai/api/search-image?query=Yale%20University%20Gothic%20architecture%20campus%20with%20historic%20stone%20buildings%20and%20courtyards%2C%20Ivy%20League%20institution%2C%20students%20walking%20between%20classes%2C%20traditional%20American%20university%20setting%2C%20professional%20photography&width=600&height=400&seq=univ-006&orientation=landscape',
    programs: 'Droit, Arts, Sciences Humaines',
    programsEn: 'Law, Arts, Humanities',
    ranking: '#5 Mondial',
    rankingEn: '#5 Worldwide',
  },
  {
    id: 'shoreline',
    name: 'Shoreline Community College',
    location: 'Shoreline, Washington',
    image: 'https://readdy.ai/api/search-image?query=Shoreline%20Community%20College%20modern%20campus%20buildings%20with%20green%20spaces%20and%20diverse%20international%20students%2C%20Pacific%20Northwest%20setting%20with%20trees%20and%20contemporary%20architecture%2C%20welcoming%20community%20college%20atmosphere%2C%20professional%20photography%20style%2C%20bright%20natural%20lighting&width=600&height=400&seq=univ-007&orientation=landscape',
    programs: 'Associate Degrees, Transfert Universitaire, Formation Professionnelle',
    programsEn: 'Associate Degrees, University Transfer, Professional Training',
    ranking: 'Top Community College',
    rankingEn: 'Top Community College',
  },
];

export default function Universities() {
  const { t, i18n } = useTranslation('common');
  const isFrench = i18n.language === 'fr';
  
  return (
    <section id="universities" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('universities.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('universities.subtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {universities.map((university, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={university.image}
                  alt={university.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
                  {isFrench ? university.ranking : university.rankingEn}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {university.name}
                </h3>
                <div className="flex items-center text-gray-600 mb-4">
                  <i className="ri-map-pin-line mr-2 text-teal-600 w-5 h-5 flex items-center justify-center"></i>
                  <span>{university.location}</span>
                </div>
                <div className="flex items-start text-gray-600 mb-4">
                  <i className="ri-book-line mr-2 text-teal-600 mt-1 w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-sm">{isFrench ? university.programs : university.programsEn}</span>
                </div>
                <Link
                  to={`/university/${university.id}`}
                  className="block w-full bg-teal-600 text-white py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer text-center"
                >
                  {t('universities.learnMore')}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
